/**
 *	api.serv.js
 */

import config from '../config.js';

class apiServ {
	
    constructor() {

        this.urls = {
            shops: config.appHostName + '/shops/services/shops',
            orangemoney: config.appHostName + '/shops/services/shops/orangemoney',
            shop: config.appHostName + '/shops/services/shop',
            appointment: config.appHostName + '/shops/services/appointment',
            citiesByDistrict: config.appHostName + '/shops/services/citiesbycounties',
            error: 'https://www.orange.ro/eroare404.html'
        };
    }

    readUrl(url) {
        return this.urls[url];
    }
}

export default apiServ;